import src from "IMAGE";
export default { src, width: 445, height: 499, blurWidth: 0, blurHeight: 0};
